module.exports = __webpack_public_path__ + "static/media/luke-skywalker.a858868e.png";